import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useGetters } from '../store/tickets';
import { getTicketPDF } from '../services/api';
import { useSnackbar } from '../../../composables/useSnackbar';


export default /*#__PURE__*/_defineComponent({
  __name: 'button-print-ticket',
  props: {
    ticketRef: { type: String, required: false },
    ticketClient: { type: String, required: false },
    ticketAccount: { type: String, required: false },
    ticketLocation: { type: String, required: false },
    size: { type: String, required: false }
  },
  setup(__props: any) {

const props = __props as {
  ticketRef?: string;
  ticketClient?: string;
  ticketAccount?: string;
  ticketLocation?: string;
  size?: string;
};

const { show } = useSnackbar();

// Props


// Local state
const downloading = ref(false);

const printTicket = async () => {
  let ticketRefToUse: string | undefined;
  let clientToUse: string | undefined;
  let accountToUse: string | undefined;
  let locationToUse: string | undefined;

  if (props.ticketRef) {
    ticketRefToUse = props.ticketRef;
    clientToUse = props.ticketClient;
    accountToUse = props.ticketAccount;
    locationToUse = props.ticketLocation;
  } else {
    const { currentTicket } = useGetters(['currentTicket']);
    ticketRefToUse = currentTicket.value?.ticket_ref;
    clientToUse = currentTicket.value?.client;
    accountToUse = currentTicket.value?.account;
    locationToUse = currentTicket.value?.location;
  }

  if (!ticketRefToUse || !clientToUse || !accountToUse || !locationToUse) {
    show('Missing ticket information to download PDF', { type: 'error' });
    return;
  }

  try {
    downloading.value = true;
    console.log(ticketRefToUse, clientToUse, accountToUse, locationToUse)
    const response = await getTicketPDF(ticketRefToUse, clientToUse, accountToUse, locationToUse);
    const base64Data = response.body || response
    
    const binaryString = atob(base64Data)
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i)
    }
    const blob = new Blob([bytes], { type: 'application/pdf'})
    
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = url;
    link.download = `ticket-${ticketRefToUse}-report.pdf`;

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading ticket report:', error);
    show('Error downloading PDF. Please try again.', { type: 'error' });
  } finally {
    downloading.value = false;
  }
};

return { __sfc: true,show, props, downloading, printTicket }
}

})